import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { de } from '@/locales/de';
import { en } from '@/locales/en';
import { es } from '@/locales/es';
import { fr } from '@/locales/fr';
import { jp } from '@/locales/jp';
import { mk } from '@/locales/mk';

export const SUPPORTED_LANGUAGES = ['en', 'de', 'es', 'fr', 'mk', 'jp'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_OPTIONS: ReadonlyArray<{ value: SupportedLanguage; label: string }> = [
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' },
    { value: 'es', label: 'Español' },
    { value: 'fr', label: 'Français' },
    { value: 'mk', label: 'Македонски' },
    { value: 'jp', label: '日本語' }
];

const LANGUAGE_STORAGE_KEY = 'language';

export function resolveSupportedLanguage(language: string): SupportedLanguage {
    return SUPPORTED_LANGUAGES.includes(language as SupportedLanguage) ? (language as SupportedLanguage) : 'en';
}

function getInitialLanguage(): SupportedLanguage {
    if (typeof window === 'undefined') {
        return 'en';
    }

    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (storedLanguage) {
        return resolveSupportedLanguage(storedLanguage);
    }

    return 'en';
}

void i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: en
        },
        de: {
            translation: de
        },
        es: {
            translation: es
        },
        fr: {
            translation: fr
        },
        mk: {
            translation: mk
        },
        jp: {
            translation: jp
        }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    }
});

void i18n.on('languageChanged', (language) => {
    if (typeof window === 'undefined') {
        return;
    }

    if (SUPPORTED_LANGUAGES.includes(language as SupportedLanguage)) {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
});

export { i18n };
